import { render } from "./BlackjackSeatElement.vue?vue&type=template&id=27cf889f&scoped=true"
import script from "./BlackjackSeatElement.vue?vue&type=script&lang=js"
export * from "./BlackjackSeatElement.vue?vue&type=script&lang=js"

import "./BlackjackSeatElement.vue?vue&type=style&index=0&id=27cf889f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cf889f"]])

export default __exports__